import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from 'react'
import ErrorHandler from '../../../lib/errorHandler';
import useSnackBar from '../../../Redux/hooks/useSnackBar';
import FilterListIcon from '@mui/icons-material/FilterList';
import usePageLoader from '../../../Redux/hooks/usePageLoader';
import NoDataFound from '../../../Component/Common/NoDataFound';
import StyledTableRow from '../../../Component/Common/StyledTableRow';
import IconBackground from '../../../Component/Common/IconBackground';
import StyledTableCell from '../../../Component/Common/StyledTableCell';
import CommonPagination from '../../../Component/Common/CommonPagination';
import { useCommonStyles } from '../../../utils';
import ViewGrnNumber from '../../../Component/PurchaseEntry/ViewGrnNumber';
import { downloadGrn, getPurchaseEntryById, getPurchaseEntrys } from '../../../Redux/Actions/PurchaseEntry';
import { Box, Button, Grid, Table, TableBody, TableContainer, TableHead, Typography, useTheme } from '@mui/material'
import { useAppSelector } from '../../../Redux/app/hooks';
import CommonSearchField from '../../../Component/Common/CommonSearchField';
import { standardDateFormat } from '../../../lib/standardDateFormat';
import StatusButton from '../../../Component/Common/StatusButton';
import downloadFileFromBlob from '../../../lib/downloadFileFromBlob';

const GrnNumber = () => {
  // =============== Hooks ===============
  const theme = useTheme();
  const { classes } = useCommonStyles();
  const dispatch = useDispatch();
  const setFullPageLoader = usePageLoader();
  const { setSnackBar } = useSnackBar();

  // =============== States ===============
  const [page, setPage] = useState(1);
  const [selectedItem, setSelectedItem] = useState({});
  const [listData, setListData] = useState({});
  const [isViewGrnNumber, setIsViewGrnNumber] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  // =============== Handler ===============
  let PerPage = 10
  const tabelHeader = ["SR.", "GRN No.", "VENDOR NAME", "Invoice No.", "Delivery Date", "Status", "Action"]

  const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);
  const handleChangePage = (e, p) => {
    setPage(p);
  };

  // ============= get Inventories API =============
  const _getGRNNumber = async (p) => {
    setFullPageLoader(true);
    let response;
    let body = {
      "limit": PerPage,
      "page": p ? p : page,
      "search": searchValue,
    }
    response = await dispatch(getPurchaseEntrys(body));
    let error = await ErrorHandler(response, setSnackBar);
    if (error) {
      if (response?.payload?.data) {
        setListData(response?.payload?.data)
      }
      setFullPageLoader(false);
    }
    setFullPageLoader(false);
  };

  // ============= Get By Id Inventory Field API =============
  const _getPurchaseOrderById = async (id) => {
    setFullPageLoader(true);
    let response;
    let body = `/${id}`
    response = await dispatch(getPurchaseEntryById(body));
    let error = await ErrorHandler(response, setSnackBar);
    if (error) {
      if (response?.payload?.data?.response) {
        const res = response?.payload?.data?.response
        setSelectedItem(response?.payload?.data?.response)
        setIsViewGrnNumber(true)

      }
      setFullPageLoader(false);
    }
    setFullPageLoader(false);
  };
  // ============= download Grn API =============
  const _downloadGrn = async (row) => {
    setFullPageLoader(true);
    const body = {
      id: row?._id
    };
    const response = await dispatch(downloadGrn(body));
    const error = await ErrorHandler(response, setSnackBar);
    if (error) {
      const blobData = response?.payload?.data;
      if (blobData) {
        const contentDisposition = response?.payload?.headers?.["content-disposition"];
        const filename =
          contentDisposition?.split("filename=")?.[1]?.split(";")?.[0]?.replace(/['"]/g, "") ||
          `GRN-${row?.GRNNUmber}.docx`;
        downloadFileFromBlob(blobData, filename);
        setFullPageLoader(false);
      } else {
        setFullPageLoader(false);
        setSnackBar("error", response?.payload?.message || "Something went wrong!");
      }
      setFullPageLoader(false);
    }
    setFullPageLoader(false);
  };
  // =============== Use Effects ===============
  useEffect(() => {
    if (searchValue) {
      _getGRNNumber();
    } else {
      _getGRNNumber();
    }
  }, [page, searchValue])

  useEffect(() => {
    setPage(1);
  }, [searchValue]);

  return (
    <>
      {isViewGrnNumber ?
        <ViewGrnNumber setSearchValue={setSearchValue} setIsViewGrnNumber={setIsViewGrnNumber} selectedItem={selectedItem} setSelectedItem={setSelectedItem} _getGRNNumber={_getGRNNumber} />
        :
        <Grid container spacing={2} padding={"25px"}>
          <Grid item xs={12} display={"flex"} justifyContent={"space-between"} alignItems={"center"} flexWrap={'wrap'}>
            <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>GRN Number List</Typography>
            <Box display={"flex"} gap={1} flexWrap={'wrap'}>
              <CommonSearchField handleSearch={(value) => setSearchValue(value)} categories={["PO Number", 'Vendor Name', 'Item Name']} />
              {/* <Button className={classes.cancelButton} startIcon={<FilterListIcon />}>Filters </Button> */}
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
              <TableContainer>
                <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                  <TableHead>
                    <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                      {tabelHeader?.map((ele) => {
                        return (
                          <StyledTableCell>{ele}</StyledTableCell>
                        )
                      })}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {listData?.response?.length > 0 ?
                      listData?.response?.map((row, index) => {
                        const allAccept = row?.purchaseOrder?.every((ele) => ele?.status == "Accept")
                        const allReject = row?.purchaseOrder?.every((ele) => ele?.status == "Reject")
                        return (
                          <React.Fragment key={index}>
                            <StyledTableRow>
                              <StyledTableCell> {index + 1 + (page - 1) * PerPage}</StyledTableCell>
                              <StyledTableCell> {row?.GRNNUmber ? row?.GRNNUmber : "NA"}</StyledTableCell>
                              <StyledTableCell> {row.vendorName ? row.vendorName : "NA"}</StyledTableCell>
                              <StyledTableCell> {row.invoiceNumber ? row.invoiceNumber : "NA"}</StyledTableCell>
                              <StyledTableCell> {row.deliveryDate ? standardDateFormat(row.deliveryDate) : "NA"}</StyledTableCell>
                              <StyledTableCell>  <StatusButton text={allAccept ? "Accepted" : allReject ? "Rejected" : "Pending"} color={allAccept ? "success" : allReject ? "red" : "gray"} /></StyledTableCell>
                              <StyledTableCell>
                                <Box display={'flex'} gap={1}>

                                  {getPermissionList?.viewPermission?.includes('Purchase Entry') &&
                                    <IconBackground icon={"visibility"} onClick={() => _getPurchaseOrderById(row?._id)} />
                                  }
                                  <IconBackground icon={"download"} onClick={() => _downloadGrn(row)} />
                                </Box>
                              </StyledTableCell>
                            </StyledTableRow>
                          </React.Fragment>
                        )
                      })
                      :
                      <StyledTableRow>
                        <StyledTableCell colSpan={12}>
                          <NoDataFound />
                        </StyledTableCell>
                      </StyledTableRow>
                    }
                  </TableBody>
                </Table>
              </TableContainer>
              <CommonPagination
                totalCount={listData?.count}
                count={Math.ceil(listData?.count / PerPage)}
                itemsPerPage={PerPage}
                page={page}
                onChange={handleChangePage}
              />
            </Box>
          </Grid>

        </Grid>
      }
    </>
  )
}

export default GrnNumber